// Paired by index with en.ts.
export const ru: readonly string[] = [
	"У армянского языка свой алфавит. Его создал Месроп Маштоц около 405 года.",
	"Маштоц придумал 36 букв. Позже армяне добавили ещё несколько.",
	"Когда-то армянские буквы были и цифрами: Ա означала 1, а Բ — 2.",
	"Дудук — духовой инструмент, вырезанный из абрикосового дерева.",
	"ЮНЕСКО охраняет музыку дудука как сокровище мировой культуры.",
	"Научное название абрикоса, Prunus armeniaca, означает «армянская слива».",
	"На флаге Армении три полосы: красная, синяя и абрикосовая.",
	"Лаваш — тонкий армянский хлеб. Его пекут на стенках глиняной печи.",
	"Ереван, столица Армении, старше Рима. Его основали в 782 году до н. э.",
	"Из Еревана видна гора Арарат — символ Армении.",
	"Озеро Севан лежит высоко в горах, примерно в 1 900 метрах над уровнем моря.",
	"В армянских школах шахматы — отдельный предмет, как математика.",
	"«Крылья Татева» — канатная дорога длиной почти 6 километров над глубоким ущельем.",
	"Армяне называют свою страну Հայաստան. Скоро ты сможешь это прочитать!",
	"Хачкары — каменные кресты с резьбой, похожей на кружево. Их тысячи по всей Армении.",
	"Самую древнюю известную кожаную туфлю — ей около 5 500 лет — нашли в армянской пещере.",
	"На Вардавар, летний праздник, люди обливают друг друга водой.",
	"Матенадаран в Ереване хранит тысячи очень старых рукописных книг.",
	"Армения первой в мире сделала христианство государственной религией — в 301 году.",
	"«Привет» по-армянски — Բարև. Попробуй прочитать это слово по буквам!",
];
